<template>
  <div class="default-vue">
    <div v-if="sessions && !error && !loading" class="rounded-s p-x-s sessions-box--style" :style="{'color': textcolor, 'background-color': backgroundcolor, 'background-image': 'url(' + backgroundimage + ')' }">
      <p v-if="headline" class="font-weight-bolder h3-blog" :style="{'color': headlinecolor}">{{headline}}</p>
      <hr class="session-blog-hr-color">
      <div v-for="aSession in sessions" :key="aSession.sessionSlug" class="session-bolg-container">
        <div style="margin-bottom: 15px;">
          <a target="_blank" class="session-name-blog-widget" :href="'/session/' + aSession.slugNames">
            <p v-if="aSession.name" class="font-weight-bolder session-name-blog-widget h4-blog">{{aSession.name}}
            </p>
          </a>
          <div v-for="anExpert in aSession.experts" :key="anExpert._id">
            <a v-if="anExpert.forename || anExpert.surname" class="archive-session-title speaker-name-blog-widget" target="_blank" :style="{'color': textcolor}"
              :href="'/speaker/' + anExpert.slug">{{anExpert.forename}}&nbsp;{{anExpert.surname}}</a>,&nbsp;
            <span v-if="anExpert.company" class="company-name-style">{{anExpert.company}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import queryAndMutaionService from '@/services/queryAndMutaionService'


export default {
  name: 'SessionsInBlog',
  props: {
     settingsPerm: Object
  },
  data() {
    return {
        Sessions: false,
        result:null,
        loading:false, 
        error:true,
        sessionSlug: this.settingsPerm.sessionslugs,
        backgroundimage: this.settingsPerm.backgroundimage,
        backgroundcolor: this.settingsPerm.backgroundcolor,
        pagecaption: this.settingsPerm.pagecaption,
        textcolor: this.settingsPerm.textcolor,      
        headline: this.settingsPerm.headline,
        subheadlinecolor: this.settingsPerm.subheadlinecolor, 
        sessionspeaker: this.settingsPerm.sessionspeaker,               
        brandId: this.settingsPerm.brandId,
        currentDate: null,
        sessions: []
      }
  },
  beforeUpdate() {
    if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length) {
      this.result.vueSessions.Sessions.forEach((aSession) => {
        let duplicate = this.sessions.find(aDupSession =>{
          return aSession.slugNames[0] == aDupSession.slugNames[0];
        })
        if (!duplicate) {
          this.sessions.push(aSession);
          
        }
      });
    }
  },
  created() {
    if (this.sessionSlug && this.sessionSlug.length) {
        this.sessionSlug = this.sessionSlug.split(",");
    } 
    if (this.sessionSlug && this.brandId) {
        let concordData = queryAndMutaionService.getSessionsBySlug(this.sessionSlug, this.brandId);
        if (concordData && concordData.result) {
            this.result = concordData.result;
        }
        if (concordData && concordData.loading) {
            this.loading = concordData.loading;
        }
        if (concordData && concordData.error) {
            this.error = concordData.error;
        }
    }    
  }
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sessions-box--style{
    padding: 20px 25px;
    background-size: cover;
  }
  .company-name-style{
    font-style: italic;
  }
</style>
